import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { PlayButton } from '../common/Icons';

const VideoModal = ({ video }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false)
  };
  const handleShow = () => setShow(true);

  return (
    <>
      <span className="play-button" onClick={handleShow} >
        <PlayButton />
      </span>

      <Modal show={show} onHide={handleClose} backdrop="true" centered size="xl" >
        <Modal.Header closeButton closeVariant="white" />
        <Modal.Body className="youtube-video" dangerouslySetInnerHTML={{ __html: video.html }} />
      </Modal>
    </>
  );
}

export default VideoModal;
